// extracted by mini-css-extract-plugin
module.exports = {"block":"DetailsOrganization_block__3yL0v"};